import { useEffect, useState } from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import Loader from '@/components/Loader';
import { FactsheetDetails } from '@/pages/Facthsheets/constants';
import RelatedCodeItem from '@/pages/Facthsheets/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/RelatedCodesTab/RelatedCodeItem';
import downloadFileFromDatalake from '@/utils/downloadFileFromDatalake';

const Flowchart = ({
  flowchartFileId,
  boxStyles
}: {
  flowchartFileId: string;
  boxStyles?: SxProps<Theme>;
}) => {
  const [imageSrc, setImageSrc] = useState<string | undefined>('');
  const [error, setError] = useState('');

  useEffect(() => {
    downloadFileFromDatalake(flowchartFileId)
      .then(imageResponse => {
        setImageSrc(URL.createObjectURL(imageResponse?.data));
      })
      .catch(error => {
        console.error(error);
        setError(error);
      });
  }, [location]);

  if (!error) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          ...boxStyles
        }}
      >
        {imageSrc ? (
          <img
            alt='factsheetImage'
            src={imageSrc}
            style={{ width: '90%' }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: 250
            }}
          >
            <Loader />
          </Box>
        )}
      </Box>
    );
  }
};
const FlowchartTab = ({
  factsheet,
  openNewTab
}: {
  factsheet: FactsheetDetails;
  openNewTab: (code: string) => void;
}) => {
  const parentsWithFlowcharts =
    factsheet.factsheetVersionHistory.length > 0
      ? factsheet.factsheetVersionHistory[0].parentsWithFlowcharts
      : [];
  const flowchartIds: string[] =
    factsheet.factsheetVersionHistory.length > 0
      ? (factsheet.factsheetVersionHistory[0].flowcharts ?? [])
      : [];

  const flowchartId1 =
    flowchartIds.length > 0 && flowchartIds[0] !== 'false' ? flowchartIds[0] : undefined;
  const flowchartId2 =
    flowchartIds.length > 1 && flowchartIds[1] !== 'false' ? flowchartIds[1] : undefined;
  if (flowchartId1 || flowchartId2) {
    return (
      <Box>
        {flowchartId1 && <Flowchart flowchartFileId={flowchartId1} />}
        {flowchartId2 && (
          <Flowchart
            boxStyles={{ mt: 4 }}
            flowchartFileId={flowchartId2}
          />
        )}
      </Box>
    );
  }
  return (
    <Box
      sx={{
        minWidth: 700
      }}
    >
      <Box>
        <Typography sx={{ fontWeight: 700, pb: 1 }}>Flowchart</Typography>
        <Typography sx={{ pb: 2 }}>None.</Typography>
        <Typography sx={{ fontWeight: 700, pb: 1 }}>Parent Code Flowchart</Typography>
        {(!parentsWithFlowcharts || parentsWithFlowcharts?.length === 0) && (
          <Typography sx={{ pb: 1 }}>None.</Typography>
        )}
        {parentsWithFlowcharts?.map((parentCode, index) => (
          <RelatedCodeItem
            key={parentCode.code + index}
            openNewTab={openNewTab}
            relatedCode={parentCode}
          />
        ))}
      </Box>
    </Box>
  );
};
export default FlowchartTab;
